<div class="modal-header flex-column align-items-start">
    <div class="d-flex w-100 justify-content-between align-items-center">
        <h4 class="modal-title mb-0">
            Cihaz & Teklif Kalemi İlişkilendirme
        </h4>
    </div>
</div>

<div class="modal-body">
    <form [formGroup]="deliveryDeviceForm">
        <div class="p-1">
            <div class="d-flex justify-content-between mb-1">
                <strong>{{ data.deviceName }}</strong>
                <span class="text-muted">{{ data.brand }} - {{ data.brandModel }}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="text-muted">{{ data.kind }}</span>
                <span class="text-muted">Seri No: {{ data.seriNo }}</span>
            </div>
        </div>
        <div class="form-group">
            <label for="company">Teklif Kalemi Seç</label>
            <div class="form-group">
                <ng-select [items]="transactionProducts" bindLabel="name" bindValue="productId"
                    formControlName="productId"></ng-select>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer d-flex">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!deliveryDeviceForm.valid"
        (click)="data.id ? onUpdateSave() : saveDeliveryDevice()">Kaydet</button>
</div>